import React from 'react'

export default function RadioGroupWrapper({ options, name, value, disabled, onChange, ...props }) {
  return <div {...props}>
    {(options || []).map(({ label, value: optValue, className, ...opt }) => {
      return <div key={optValue} className={className}>
        <input {...opt} name={name} value={optValue} className={className} id={optValue} disabled={disabled || opt.disabled} onChange={onChange} checked={value == optValue} type='radio'/>
        <label className={className} htmlFor={optValue}>{label}</label>
      </div>
    })}
  </div>
}
